import { render, staticRenderFns } from "./Kccshlc.vue?vue&type=template&id=9571b210&scoped=true&"
import script from "./Kccshlc.vue?vue&type=script&lang=js&"
export * from "./Kccshlc.vue?vue&type=script&lang=js&"
import style0 from "./Kccshlc.vue?vue&type=style&index=0&id=9571b210&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9571b210",
  null
  
)

export default component.exports